import PropTypes from 'prop-types'

const createWrapperAndAppendToBody = (wrapperId) => {
  const wrapperElement = document.createElement('div')
  wrapperElement.setAttribute('id', wrapperId)
  document.body.appendChild(wrapperElement)
  return wrapperElement
}

export default createWrapperAndAppendToBody

createWrapperAndAppendToBody.propTypes = {
  wrapperId: PropTypes.string.isRequired,
}
